import Card from "../Card";
import './HomeMain.scss';


function HomeMain() {
    return (
        <main className="main">
            <div className="main__wrapper">
                <Card />
            </div>
        </main>
    );
}

export default HomeMain;